<ng-container>
  <div class="services-container">
    <h1 [title]="'Our services' | trans" class="services-container-title">{{ 'Our services' | trans }}</h1>

    <div class="service-items">
      @for (service of services(); track service.slug) {
        <service-card [item]="service" />
      }
    </div>
  </div>
</ng-container>
